<template>
	<div class="__report-lesson px-12 md-down:px-4 pb-30">
		<div
			class="__report-lesson__header pt-10 flex flex-nowrap justify-between md-down:flex-col md-down:gap-6"
		>
			<div
				class="__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl"
			>
				<svg
					class="mr-3 h-6 w-6"
					fill="none"
					viewBox="0 0 28 28"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M19.3472 7H8.65324C8.65324 7 1.16663 13.6309 1.16663 21.3691C1.16663 25.7888 4.3861 28 6.51361 28H21.4863C23.6228 28 26.8333 25.7886 26.8333 21.3691C26.8333 13.6309 19.3467 7 19.3467 7H19.3472ZM15.0684 22.3615V24.1312H12.932L12.9318 22.3674C11.3572 22.0648 10.368 21.0606 10.2978 19.6025H12.1505C12.2411 20.3678 12.9875 20.861 14.0675 20.861C15.0625 20.861 15.7679 20.3619 15.7679 19.651C15.7679 19.0461 15.3114 18.7011 14.1875 18.4411L12.9963 18.178C11.328 17.818 10.5085 16.9195 10.5085 15.4766C10.5085 14.0337 11.4393 12.9929 12.9202 12.6511V10.8691H15.0566V12.6539C16.5024 12.9866 17.4654 14.006 17.5121 15.3763L15.724 15.3765C15.6333 14.6293 14.96 14.1303 14.0352 14.1303C13.1105 14.1303 12.4431 14.5901 12.4431 15.3101C12.4431 15.894 12.8791 16.2177 13.9532 16.4656L15.0566 16.7077C16.8975 17.1069 17.6905 17.9176 17.6905 19.397C17.6907 20.979 16.7074 22.0379 15.0684 22.3615L15.0684 22.3615Z"
						fill="#65758B"
					/>
					<path
						d="M18.8636 1.16214H16.175C15.6196 0.422379 14.8294 0 14.0001 0C13.1709 0 12.3806 0.422402 11.8252 1.16214H9.13669C8.81509 1.1637 8.51503 1.35595 8.33454 1.67554C8.15405 1.99513 8.11655 2.40126 8.23427 2.76078L9.13667 5.83333H18.8632L19.7657 2.76078C19.8834 2.40126 19.8459 1.99515 19.6654 1.67554C19.4849 1.35593 19.1849 1.16371 18.8632 1.16214H18.8636Z"
						fill="#65758B"
					/>
				</svg>

				Quản lý học phí
			</div>
			<div class="flex items-center md:justify-center">
				<template v-if="$route.name === _ROUTER_NAME.FEE_NOTICES">
					<button
						class="h-12 button-p btn--ghost text-center mr-3 px-6 whitespace-nowrap"
						type="button"
						@click.stop="triggerFeeNotice('create')"
					>
						Tạo thông báo mới
					</button>
					<div
						class="w-30 bg-white p-3 rounded-md border shadow-sm border-neutral-200 cursor-pointer flex items-center"
						@click="triggerFeeNotice('filter')"
					>
						<svg
							fill="none"
							height="16"
							viewBox="0 0 16 16"
							width="16"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								clip-rule="evenodd"
								d="M1 3.66797C1 3.11568 1.44772 2.66797 2 2.66797H14C14.5523 2.66797 15 3.11568 15 3.66797C15 4.22025 14.5523 4.66797 14 4.66797H2C1.44772 4.66797 1 4.22025 1 3.66797Z"
								fill="#94A3B8"
								fill-rule="evenodd"
							/>
							<path
								clip-rule="evenodd"
								d="M2.33203 8C2.33203 7.44772 2.77975 7 3.33203 7H12.6654C13.2176 7 13.6654 7.44772 13.6654 8C13.6654 8.55228 13.2176 9 12.6654 9H3.33203C2.77975 9 2.33203 8.55228 2.33203 8Z"
								fill="#94A3B8"
								fill-rule="evenodd"
							/>
							<path
								clip-rule="evenodd"
								d="M4.33203 12C4.33203 11.4477 4.77975 11 5.33203 11H10.6654C11.2176 11 11.6654 11.4477 11.6654 12C11.6654 12.5523 11.2176 13 10.6654 13H5.33203C4.77975 13 4.33203 12.5523 4.33203 12Z"
								fill="#94A3B8"
								fill-rule="evenodd"
							/>
						</svg>
						<div
							class="ml-1.5 font-semibold text-neutral-600 whitespace-nowrap"
						>
							Bộ lọc
						</div>
					</div>
				</template>
				<button
					v-if="
						$route.name !== _ROUTER_NAME.TUITION_FORMS &&
						$route.name !== _ROUTER_NAME.FEE_NOTICES &&
						$route.query.empty === 'true'
					"
					class="button-p btn--ghost w-fit px-4 h-12"
					type="button"
					@click="handleCreateTuition"
				>
					Thêm chi phí
				</button>
				<button
					v-if="$route.name !== _ROUTER_NAME.FEE_NOTICES"
					class="button-p btn--ghost w-fit px-4 h-12"
					type="button"
					@click="goToCreate"
				>
					Tạo biểu mẫu mới
				</button>
			</div>
		</div>
		<div>
			<div class="my-10">
				<div class="border-b border-neutral-200">
					<nav aria-label="Tabs" class="flex space-x-8 tabs">
						<router-link
							v-for="tab in tabs"
							:key="tab.id"
							:to="{
								name: tab.link,
								query: {},
							}"
							class="border-transparent hover:text-yellow-700 hover:border-yellow-500 text-neutral-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold cursor-pointer"
						>
							<div class="flex items-center gap-2">
								<div>{{ tab.name }}</div>
							</div>
						</router-link>
					</nav>
				</div>
			</div>
		</div>
		<div>
			<router-view
				:createTuition="createTuition"
				:feeNoticeAction="feeNoticeAction"
			></router-view>
		</div>
	</div>
</template>

<script>
import { _ROUTER_NAME } from '@/enums';

export default {
	computed: {
		_ROUTER_NAME() {
			return _ROUTER_NAME;
		},
	},
	data() {
		return {
			isLoading: false,
			tabs: [
				{
					id: 0,
					name: 'Thông báo học phí',
					link: _ROUTER_NAME.FEE_NOTICES,
				},
				{
					id: 1,
					name: 'Biểu mẫu',
					link: _ROUTER_NAME.TUITION_FORMS,
				},
				{
					id: 2,
					name: 'Chi phí',
					link: _ROUTER_NAME.TUITION_SETTING,
				},

				{
					id: 3,
					name: 'Cài đặt',
					link: _ROUTER_NAME.TUITION_SETUP,
				},
			],
			createTuition: 0,
			feeNoticeAction: {
				type: '',
				key: 0,
			},
		};
	},

	methods: {
		handleCreateTuition() {
			this.createTuition = this.createTuition + 1;
			setTimeout(() => {
				this.createTuition = 0;
			}, 100);
		},

		triggerFeeNotice(type) {
			this.feeNoticeAction = {
				type,
				key: Date.now(),
			};
		},

		goToCreate() {
			window.sessionStorage.removeItem('formPreview');
			this.$router.push({ name: _ROUTER_NAME.TUITION_FORMS_CREATE });
		},
	},
};
</script>
<style lang="scss" scoped>
.tabs {
	.router-link-exact-active {
		@apply text-yellow-700 border-yellow-500;
	}
}
</style>
